import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase';
import VueFullPage from 'vue-fullpage.js'
import VueMeta from 'vue-meta'
import VueConfetti from 'vue-confetti'
import { firebaseConfig } from '../firebase-config.js'
const { Parser } = require('json2csv');

firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false

Vue.use(VueFullPage);
Vue.use(VueMeta);
Vue.use(VueConfetti);

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.mixin({
  methods: {
    exportDB(dbContext) {
      var jsonOutput = [];
      console.log('exporting database...');
      store.commit('exporting');
      firebase.firestore().collection(dbContext).get().then((docs) => {

          docs.forEach((doc) => {
              jsonOutput.push(doc.data());
          });

          var fields = [];
          var opts = {};

          if(dbContext == 'skills_library') {
            fields = ['area', 'category', 'employee', 'email'];
            opts = { fields };
          } else if(dbContext == 'knowledge_management') {
            fields = ['area', 'category', 'designation', 'employeeName', 'employeeEmail', 'subcategory'];
            opts = { fields };
          } else if(dbContext == 'client_knowledge') {
            fields = ['designation', 'employeeName', 'employeeEmail', 'firm'];
            opts = { fields };
          }

          //handle CSV parse

          try {
            console.log(opts);
            console.log(jsonOutput);
            var parser = new Parser(opts);
            var csv = parser.parse(jsonOutput);
            console.log(csv);

            var file = dbContext + '-' + Date.now();

            //handle file upload

            console.log('handling CSV file upload...');

            const blob = new Blob([csv], {type : 'text/csv'});

            var task = firebase.storage().ref('CSV_data_exports/' + file + '.csv').put(blob);
            var percentage = 0;

            task.on('state_changed', function progress(snapshot) {
              console.clear();
              percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log(percentage + '%');
            }, function error(err) {
              console.error('There was a problem uploading the file:', err);
            }, function complete() {
              task.snapshot.ref.getDownloadURL().then(
                function(downloadURL) {
                  store.commit('exportComplete');
                  console.log('SUCCESS!');
                  console.log('File available at ' + downloadURL);
                  store.commit('exportURL', downloadURL);
                }
              )
            })
            
          } catch (err) {
            console.error(err);
          }

      });
    },
  },
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
